export default [
  {
    campaignname: "ABC",
    Spending: "0",
    pushNotification: "10",
    startdate: "25 May 2021",
    enddate: "30 May 2021"
  },
  {
    campaignname: "ABC",
    Spending: "0",
    pushNotification: "5",
    startdate: "25 May 2021",
    enddate: "30 May 2021"
  },
  {
    campaignname: "ABC",
    Spending: "0",
    pushNotification: "3",
    startdate: "25 May 2021",
    enddate: "30 May 2021"
  },
  {
    campaignname: "ABC",
    Spending: "0",
    pushNotification: "4",
    startdate: "25 May 2021",
    enddate: "30 May 2021"
  }
];
